import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpHeaders,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { AuthService } from './auth.service';
import { HttpResponse } from 'selenium-webdriver/http';
import { SemsoSnackbarService } from './semso-snackbar.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private auth: AuthService, private snackbar: SemsoSnackbarService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${this.auth.getToken()}`
            },
            url: `${environment.api}${request.url}`,
        });

        return next.handle(request)
        .do(() => {}, (error: any) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    this.auth.signout();
                    this.auth.startAuthentication();
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth-interceptor.ts